export default "__VITE_ASSET__Cbv8Hhrd__"